import { render } from "./Register.vue?vue&type=template&id=3a842a9d"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Active\\Workspace\\www\\ETDotCom_v2\\EndlessTheoryDotCom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__